import React from 'react';
import Layout from './hoc/Layout/Layout';
import Quiz from './Containers/Quiz/Quiz';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import QuizList from './Containers/Quizlist/Quizlist';
import Auth from './Containers/Auth/Auth';
import QuizCreator from './Containers/QuizCreator/QuizCreator';
import { connect } from 'react-redux';
import Logout from './Components/Logout/Logout';
import { autoLogin } from './Store/actions/auth';

class App extends React.Component {

    componentDidMount () {
        this.props.autoLogin()
    }
    
    render() {



        let routes = (
            <Switch>
                <Route path='/auth' component={Auth} />
                <Route path='/quiz/:id' component={Quiz} />
                <Route path='/' exact component={QuizList} />
                <Redirect to='/' />
            </Switch>
        );

        if (this.props.isAuthenticated) {
            routes = (
                <Switch>
                    <Route
                        path='/quiz-creator'
                        component={QuizCreator}
                    />
                    <Route path='/quiz/:id' component={Quiz} />
                    <Route path='/logout' component={Logout} />
                    <Route path='/' exact component={QuizList} />

                    <Redirect to='/' />
                </Switch>
            );
        }

        return (
            <Layout>
                {routes}
            </Layout>
        );
    }
}
function mapStateToProps (state) {
    return {
        isAuthenticated: !!state.auth.token 
    }
}

function mapDispatchToProps (dispatch) {
    return{ 
        autoLogin: () => dispatch(autoLogin())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
